import React from 'react';
import { IWizardItem } from '../WizardItem';
import Text from '../../../../BaseModule/Components/Text';
import { WizardItemSubtype } from '../../../Enums/WizardItemSubtype.enum';
// @ts-ignore
import styles from 'WizardText.module.scss';
import NoEscape from '../../../../../Utils/NoEscape';

interface Props {
	item: IWizardItem;
}

const WizardText: React.FC<Props> = ({ item }) => {
	switch (item.subtype) {
		case WizardItemSubtype.HEADER:
			return <Text tx={item.title} className={styles.header} />;
		case WizardItemSubtype.HTML:
			return <NoEscape children={item.title} />;
		case WizardItemSubtype.NORMAL:
		default:
			return <Text tx={item.title} className={styles.normal} />;
	}
};

export default WizardText;
